<template>
	<div>
		<Breadcrumbs main="" title="reuse.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid search-page">
            <div class="row col-sm-12 ml-1">
                <div class="ml-3 mt-1" > 
                    <span for="selectedCompName" class=" text-primary pt-0 f-w-600" style="font-size: 20px">{{ $t("register.compId") }}</span>          
                </div>
                <div class="col-sm-5 ml-3">
                    <v-select label="selectedCompName" v-model="selectedCompName" :options="compNameListLogist" @input="reuseComp" class=" text-primary pt-0 f-w-600" style="font-size: 20px;">
                    </v-select> 
                </div>    
            </div>
            <div>
                <h4 class="mb-1 mt-4 f-w-600">{{ $t('reuse.activeReuseList') }} - Company</h4>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                >
                    <template #cell(addressReu)="row" >
                        <b-button  size="sm" v-b-popover.hover.top="row.item.contReuAddress" variant="outline-info">
                            {{ $t('matchTx.reqr') }}
                        </b-button>
                    </template>
                    <template #cell(contImage)="row" >
                        <b-button  size="sm" @click="openModalImage(row.item, row.index, $event.target )" class="m-1">
                            {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
                        </b-button>
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                    <!-- Info modal Container Image-->
                <b-modal id="contModal" :title="modalTitle" ok-only @hide="resetInfoModal">
                    <div class="gradient-yg p-1" >
                        <div class="dashboard">
                            <div class="image-scroll-container">
                                <div class="image-scroll" ref="scrollContainer">
                                    <div
                                    class="image-item"
                                    v-for="(image, index) in imageUriModal"
                                    :key="image.id"
                                    >
                                    <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                    <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                                    </div>
                                    <div v-if="imageUriModal.length === 0" class="no-images">
                                    {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                </div>
                                <div class="scroll-controls" v-if="imageUriModal.length > 1">
                                    <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                    <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                    <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                    <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                </div>
                            </div>                        
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>

import { getData, compNameListLogist, compIdByCompName} from "../../firebase"
export default {
	data(){
		return{
            compNameListLogist : [],
            selectedCompName : '',
            selectedCompId : '',
            items: [],
            fields: [
                { key: 'reuId', label: this.$t('require.reqrId'), sortable: true, },  
                { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, }, 
                { key: 'agent', label: this.$t('require.agentByBkgId'), sortable: true, },                    
                { key: 'contImage', label: this.$t('container.contNo'), variant: 'info'}, 
                { key: 'detDate', label: this.$t('container.detDate'), sortable: true, },                 
                { key: 'sealNo', label: this.$t('seal.sealNo'), sortable: true,},
                { key: 'contType', label: this.$t('require.contType'), sortable: true, },
                { key: 'contSize', label: this.$t('require.contSize'), sortable: true, },
                { key: 'contGrade', label: this.$t('require.contGrade'), sortable: true, },
                { key: 'compNameLocalReu', label: this.$t('reuse.compNameLocalReu'), sortable: true, },  
                { key: 'addressReu', label: this.$t('matchTx.address'), sortable: false, }, 
                // { key: 'contReuAddress', label: this.$t('matchTx.contReqrAddress'), sortable: false, },              
                { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YY @ HH:mm")
                }},
                { key: 'status', label: this.$t('matchTx.jobStatus'), variant: 'warning', sortable: true,
                    formatter: value => {
                        return this.$t(`reuse.${value}`)
                }},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'timestamp',
            sortDesc: true,
            sortDirection: 'asc',
            imageUriModal: [],
            modalTitle : ''
		}
	},
	mounted(){
        compNameListLogist((res)=>{
            this.compNameListLogist = res
        })
	},
	methods:{
        async reuseComp(){
            if (this.selectedCompName) {
                await compIdByCompName(this.selectedCompName , async(selCompId)=>{
                    this.selectedCompId = selCompId
                    await getData( "Reuse", 'compId', selCompId , (res)=>{
                        this.items= res
                        this.totalRows = res.length
                })
                })          
            }
        },

        async refresh(){
            await getData( "Reuse", 'compId' ,this.selectedCompId , (res)=>{
                this.items= res
                this.totalRows = res.length
            })
        },

        async openModalImage(item, index, button) {
            await getData('Container' , 'contId' , item.contId , (res)=>{
            this.imageUriModal = res[0].url6  
            this.modalTitle = res[0].contNo   
            this.$root.$emit('bv::show::modal', "contModal" , button)                                  
            })
        },
        resetInfoModal() {
            this.modalTitle = ''
            this.imageUriModal = []
        },
        scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
}
</script>
<style scoped>
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>

